<template>
  <ul :class="columnClass" class="d-flex nav nav-navbar mr-auto">
    <li class="nav-item">
      <a class="nav-link" href="../#list-vacancy">
      Vagas disponíveis
      </a>
    </li>

    <li class="nav-item">
      <a class="nav-link" href="../#about-company">
      Sobre nós
      </a>
    </li>

    <li class="nav-item">
      <a v-if="currentScopedCompanyPage.site_url" class="nav-link" target="_blank" :href="currentScopedCompanyPage.site_url">
        Acessar nosso site
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'MenuLoggedOut',
  props: {
    currentScopedCompanyPage: {
      type: Object,
      required: true,
    },
    sidebar: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    columnClass() {
      return this.sidebar ? 'flex-column' : 'flex-row nav-transform-none';
    }
  }
};

</script>
